import router from '../../router'
import {allowOnlyAuthorized} from '../../router/routeGuards'

import VideoCutting from './VideoCutting.vue'
import AppHeader from '../../components/layout/Header'

// Setup routes
export default () => {
  router.addRoutes([
    {
      path: '/video-cutting/:projectId',
      name: 'video-cutting',
      components: {
        default: VideoCutting,
        header: AppHeader
      },
      meta: {
        dontShowInMenu: true,
        highlightProject: true,
      },
      beforeEnter: allowOnlyAuthorized()
    }
  ])
}
